var _rect, _rect2, _line, _line2, _line3, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoChartData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 138 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135.364,
    height: 99,
    x: 1.318,
    y: 1.334,
    fill: "#fff",
    stroke: "#E2E6EF",
    rx: 4.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 16.236,
    y: 22.652,
    fill: "#E2E6EF",
    rx: 4.091
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35.035,
    x2: 121.762,
    y1: 26.243,
    y2: 26.243,
    stroke: "#E2E6EF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 35.035,
    x2: 121.762,
    y1: 44.425,
    y2: 44.425,
    stroke: "#E2E6EF"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 35.035,
    x2: 121.762,
    y1: 62.607,
    y2: 62.607,
    stroke: "#E2E6EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 16.236,
    y: 40.834,
    fill: "#E2E6EF",
    rx: 4.091
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#25E47A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M36.0479 62.3934H53.5803L68.7751 44.6661H83.5803L99.5543 26.0298L115.918 44.6661"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 16.236,
    y: 59.016,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 34.159,
    y: 70.834,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 49.743,
    y: 70.834,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 65.327,
    y: 70.834,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 80.912,
    y: 70.834,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 96.497,
    y: 70.834,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 112.081,
    y: 70.834,
    fill: "#E2E6EF",
    rx: 4.091
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFDCF6",
    d: "M67.0146 56.6142C67.0146 55.5383 67.8868 54.6661 68.9627 54.6661C70.0386 54.6661 70.9108 55.5383 70.9108 56.6142V63.1067H67.0146V56.6142Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFDCF6",
    d: "M82.4707 56.6142C82.4707 55.5383 83.3429 54.6661 84.4188 54.6661C85.4946 54.6661 86.3668 55.5383 86.3668 56.6142V63.1067H82.4707V56.6142Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFDCF6",
    d: "M97.9268 49.3415C97.9268 48.2656 98.7989 47.3934 99.8748 47.3934C100.951 47.3934 101.823 48.2656 101.823 49.3415V63.1068H97.9268V49.3415Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFDCF6",
    d: "M113.64 56.6142C113.64 55.5383 114.512 54.6661 115.588 54.6661C116.664 54.6661 117.536 55.5383 117.536 56.6142V63.1067H113.64V56.6142Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChartData);
export default __webpack_public_path__ + "static/media/NoChartData.67f0e8272be223548be278c387326ed7.svg";
export { ForwardRef as ReactComponent };